import { render, staticRenderFns } from "./v-1.vue?vue&type=template&id=c889e08e&scoped=true&"
import script from "./v-1.vue?vue&type=script&lang=js&"
export * from "./v-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c889e08e",
  null
  
)

export default component.exports